export default {
    // Currently used
    home_search_for_product: "Cherchez votre produit",
    conventional_alternative: "Alternative conventionnelle",
    led_alternative: "Alternative LED",
    search_filters_filter: "Filtre",
    alt_filters_filter: "Filtre Alternative LED",
    search_submit: "Recherche de produits",
    results: "Résultats",
    selected_product: "Produit sélectionné",
    search_input: "Saisissez (une partie) du code ou de la description du produit.",
    what_type_are_you_looking_for: "Quel type de remplacement de produit recherchez-vous?",
    recommendations_singular: "Recommandations",
    recommendations_plural: "Recommandations",
    your_product: "Votre produit",
    search_filters_reset: "Réinitialiser les filtres",
    results_specify: "Il y a plus de 10 résultats, veuillez préciser votre recherche.",
    energy_efficient: "Efficacité énergétique",
    active_filters: "Filtres actifs",
    card_action: "Catalogue",
    card_show_more: "Afficher plus",
    card_show_less: "Afficher moins",
    card_alternative_fit: "La meilleure alternative de Philips",
    card_perfect_fit: "Le meilleur ajustement de Philips",
    no_results_found: "Aucun résultat n'a été trouvé. Veuillez essayer une autre requête de recherche",
    results_no_recommendations: "Vous êtes coincé ? Veuillez contacter votre responsable de compte local ou votre représentant commercial pour trouver une solution.",
    ballast_notice: "La liste de compatibilité pour les ballasts électroniques (HP) nécessite d’être vérifiée",
    ballast_notice_tled_link_text: "Liste de compatibilité Tubes LED",
    ballast_notice_pl_led_link_text: "Liste de compatibilité PL LED",

    // LED facets
    search_filter_product_type: "Type de produit",
    lighting_type: "Type de lampe",
    ean: "EAN",
    product_code: "Code produit",
    eoc: "EOC",
    family: "Famille",
    discrete_wattage: "Wattage",
    wattage: "Wattage",
    brand: "Marque",
    driver_type: "Type de ballast",
    number_of_lamps: "Nombre de lampes",
    length: "Longueur",
    color: "Couleur",
    base: "Base",
    local_eoc: "Numéro de commande",
    energy_saving: "Économie d'énergie",
    tiering: "Sous-gamme",
    ballast_compatibility: "Compatibilité Ballast",
    lifetime: "Durée de vie",

    // Conventional facets
    ignitor: "Amorceur",
    height: "Hauteur",
    width: "Largeur",
    mounting_hole: "Trou de montage",
    mains_voltage: "Tension du réseau",
    thermal_protection: "Protection thermique",
    delta_temperature: "La température delta",
    energy_efficiency: "Efficacité énergétique",
    losses: "Puissance dissipée",
    lamp_current: "Courant de la lampe",
    pf_cap: "Facteur de puissance",
};
